import { useState } from "react";
import { validateFieldValue } from "../../config/fieldConfig/formValidation";
import { useFieldResolver } from "../../hooks/useFieldResolver";
import type { KYCFormData } from "../../types";
import { FormField } from "../form/FormField";
import { FormSection } from "../form/FormSection";

interface Step5Props {
	formData: KYCFormData;
	updateFormData: (updates: Partial<KYCFormData>) => void;
}

const Step5Limits: React.FC<Step5Props> = ({ formData, updateFormData }) => {
	const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});

	const { fields } = useFieldResolver(
		{
			incorporationCountry: formData.countryOfIncorporation,
			entityType: formData.entityType,
			flowType: "KYB",
		},
		formData as unknown as Record<string, unknown>,
	);

	const step5Fields = fields.filter((f) => f.step === 5);
	const formValues = formData as unknown as Record<string, unknown>;

	const handleChange = (fieldId: string, value: unknown) => {
		updateFormData({ [fieldId]: value } as Partial<KYCFormData>);
		// Clear error when user edits
		if (fieldErrors[fieldId]) {
			setFieldErrors((prev) => {
				const next = { ...prev };
				delete next[fieldId];
				return next;
			});
		}
	};

	const handleBlur = (fieldId: string) => {
		const field = step5Fields.find((f) => f.fieldId === fieldId);
		if (!field) return;
		const err = validateFieldValue(field, formValues[fieldId], formValues);
		setFieldErrors((prev) => ({
			...prev,
			[fieldId]: err ?? "",
		}));
	};

	return (
		<div className="w-full">
			<FormSection title="Limits & Controls">
				{step5Fields.map((field) => (
					<FormField
						key={field.fieldId}
						config={field}
						value={formValues[field.fieldId]}
						onChange={handleChange}
						onBlur={handleBlur}
						error={fieldErrors[field.fieldId] || undefined}
					/>
				))}
			</FormSection>
		</div>
	);
};

export default Step5Limits;
